/**
 * Date display helpers. Formatting happens where rows are BUILT, never in a
 * template binding (ui-best-practices §7 / NG0100: no time-dependent method
 * calls in templates).
 */

/** "Aug 11, 2026" from an ISO timestamp; null when absent/unparseable. */
export function FormatDisplayDate(iso: string | null | undefined): string | null {
    if (!iso) return null;
    const t = Date.parse(iso);
    if (Number.isNaN(t)) return null;
    return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(t));
}
